import React from 'react';
import { formatNumber } from '../../../utils/formatters';
import { Delta, SectionHead, monthLabel, monthLabelFull, PREV_LABELS, fmtPct } from './shared';
import { LeafIcon } from './icons';
import FirstVisit from '../../loyalty/FirstVisit';

/**
 * Новички: одно главное число (сколько новых вернулись) и когорты по
 * месяцам. Раньше то же самое было трижды — спарклайн, воронка и когорты.
 * Когорты всегда за год: на 30 днях месячных когорт просто нет.
 */
const NewcomersBlock = ({ newcomers, previous, deltaBase, cohorts, days, definition, periodNote, firstVisitNote, prevLabel }) => {
  const maxCohort = Math.max(1, ...cohorts.map((c) => c.new_guests));

  return (
    <>
      <section className="panel crma-section">
        <SectionHead
          icon={<LeafIcon size={18} className="heading-icon" />}
          title="Новички"
          sub={definition || 'Новый гость — тот, кто не приходил весь предыдущий год'}
        />

        <div className="crma-newcomers">
          <div className="crma-newcomers-lead">
            <div className="crma-kpi-row">
              <span className="crma-big">{fmtPct(newcomers.conversion)}</span>
              <Delta
                current={(deltaBase || newcomers).conversion}
                previous={previous?.conversion}
                kind="pp"
                title={prevLabel || PREV_LABELS[days]}
              />
            </div>
            <p>
              новых гостей пришли ещё хотя бы раз: <b>{formatNumber(newcomers.returned)}</b> из{' '}
              <b>{formatNumber(newcomers.new_guests)}</b>
            </p>
            <p className="crma-note">
              {periodNote || 'На коротком периоде доля ниже: у гостя было меньше времени вернуться.'}
            </p>
          </div>

          {cohorts.length > 0 && (
            <div className="crma-cohorts">
              <div className="crma-cohort-cols">
                {cohorts.map((c, i) => {
                  const last = i === cohorts.length - 1;
                  return (
                    <div
                      className="crma-cohort-col"
                      key={c.month}
                      title={`${monthLabelFull(c.month)}: ${c.new_guests} новых, вернулись ${c.returned} (${fmtPct(c.conversion)})`}
                    >
                      <span className="crma-cohort-pct">{Math.round(c.conversion)}%</span>
                      <span className="crma-cohort-track">
                        <span
                          className={`crma-cohort-total ${last ? 'is-partial' : ''}`}
                          style={{ height: `${(c.new_guests / maxCohort) * 100}%` }}
                        >
                          <span
                            className="crma-cohort-back"
                            style={{ height: `${c.new_guests ? (c.returned / c.new_guests) * 100 : 0}%` }}
                          />
                        </span>
                      </span>
                      <span className="crma-cohort-month">{monthLabel(c.month)}{last ? '*' : ''}</span>
                    </div>
                  );
                })}
              </div>
              <div className="crma-legend">
                <span><i className="crma-swatch crma-swatch--cohort" /> Пришли впервые</span>
                <span><i className="crma-swatch crma-swatch--returning" /> Из них вернулись</span>
                <span className="crma-dim">* у последнего месяца было меньше времени на возврат</span>
              </div>
            </div>
          )}
        </div>
      </section>

      {firstVisitNote && <p className="crma-footnote">{firstVisitNote}</p>}
      <FirstVisit />
    </>
  );
};

export default NewcomersBlock;
